if (typeof Shopify.getCart === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if (!cart) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (typeof callback === 'function') {
            callback(cart);
          } else if (typeof Shopify.onCartUpdate === 'function') {
            Shopify.onCartUpdate(cart);
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    } else {
      if (typeof callback === 'function') {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

class CustomAddtocartQuantityHandle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('cartDataUpdate',(event)=> { 
      const variantId = event.detail.variant
      const quantity = event.detail.quantity
      this.updateVariantButton(variantId, quantity)
    })
    this.productForm = this.closest('product-form');
    this.form = this.productForm.querySelector('form')
    this.cartNotification = document.querySelector('cart-notification');
    const variantId = this.form.querySelector("input[name=id]").value;

    //INIT Data 
    // this.cartData(variantId)

    this.quantityMinus = this.querySelector('.quantity-decrease__button');
    this.quantityPlus = this.querySelector('.quantity-increase__button');

    this.quantityMinus?.addEventListener('click', (e) => {
      this.onRemoveHandler(e);
    })
    this.quantityPlus?.addEventListener('click', this.onSubmitHandler.bind(this));
    
  }

  async onRemoveHandler(e) {
    this.buttonText = this.querySelector('.product-quantity__text')
    const variantId = this.buttonText.getAttribute('data-cart-variant')
    const variantQuantity = parseInt(this.buttonText.getAttribute('data-cart-quantity')) - 1
    this.buttonText.innerHTML = `${variantQuantity}`
    this.buttonText.setAttribute('data-cart-quantity', variantQuantity)
    

    if (variantQuantity == 0) {
      this.addTocartBtn = this.productForm .querySelector('.product-form__submit')
      this.addTocartBtn.style.display = 'flex'
      this.style.display = "none"
    }
    if (variantQuantity >= 0) {
      const formData = {
        id : variantId,
        quantity: variantQuantity
      };
      
      // This is calling the remove function in mm-ajaxcart.js
      window.mmajaxcart.AjaxcartChangeHandler(formData);    
    }
  }

  async onSubmitHandler() {
    this.cartNotification.setActiveElement(document.activeElement);
    const variantId = this.form.querySelector("input[name=id]").value
    
    const submitButton = this.querySelector('[type="button"]');
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    let body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      this.cartData(variantId);
      Shopify.getCart(function(parsedState){});
      this.cartNotification.renderContents(parsedState);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
    });  
  }

  updateVariantButton(variant, quantity) {
    try {
      const variantInputs = document.querySelectorAll(`input[value='${variant}']`);

      if (!variantInputs || variantInputs.length === 0) {
        console.warn(`No variant inputs found for variant: ${variant}`);
        return;
      }

      variantInputs.forEach((input) => {
        try {
          const variantForm = input.closest('product-form');
          if (!variantForm) {
            console.warn('No product-form found for input:', input);
            return;
          }

          const parentQuantityEle = variantForm.querySelector('customaddtocart-quantity-handler');
          const quantityButton = variantForm.querySelector('.product-quantity__text');
          const submitButton = variantForm.querySelector('.product-form__submit');

          if (!quantityButton || !submitButton || !parentQuantityEle) {
            console.warn('Missing elements in variant form:', { variantForm });
            return;
          }

          if (quantity > 0) {
            quantityButton.textContent = `${quantity}`;
            quantityButton.setAttribute('data-cart-quantity', quantity);
            submitButton.style.display = 'none';
            parentQuantityEle.style.display = 'flex';
          } else {
            submitButton.style.display = 'flex';
            parentQuantityEle.style.display = 'none';
          }
        } catch (innerErr) {
          console.error('Error while updating a variant form:', innerErr);
        }
      });
    } catch (err) {
      console.error('Error in updateVariantButton:', err);
    }
  }

  async cartData(variant) {
    await fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const data = cart.items.map((each) => {
        if (each.id == variant) {
          const submitButton = this.querySelector('[type="button"]');
          this.addTocartBtn = this.productForm .querySelector('.product-form__submit')
          this.addTocartBtn.style.display = 'none';
          this.buttonText = this.querySelector('.product-quantity__text');
          this.buttonText.setAttribute('data-cart-quantity',each.quantity);
          this.buttonText.setAttribute('data-cart-variant',each.id);
          this.style.display = "flex"
          this.buttonText.textContent = `${each.quantity}`

          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        }         
      })
    });
  }
}
customElements.define('customaddtocart-quantity-handler', CustomAddtocartQuantityHandle);